var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Button from '../../Button';
import { getClass } from '../../_lib/helper';
function PrimaryButton(props) {
    var className = getClass('elmo-split-btn__primary', props.className);
    return React.createElement(Button, __assign({}, props, { className: className }));
}
export default PrimaryButton;
